<template>
  <div class="g-product-list bg-white min-height-unset">
    <v-container fluid class="p-0">
      <v-layout row wrap class="g-card related-product-card">
        <v-card-text>
          <h2>
            {{$t('products.related_products')}}
          </h2>
        </v-card-text>
        <v-flex xs12 sm6 md4 lg3 v-for="(item) in $props.relatedProducts" :key="item.id" :class="{ 'ex-height' : $props.relatedProducts.length <= 4 }"
                class="g-product-list-item pl-0">
          <v-card>
            <router-link :to="'/products/' + item.id + '/' + item.displayDetails.name.replace(/\s+/g, '-')">
              <v-layout class="g-item-list">
                <div v-if="item.image" @click = "$router.push('/products/' + item.id + '/' + item.displayDetails.name.replace(/\s+/g, '-'))" class="g-card-img1" >
                  <img :src="`${ROOT_API}${item.image}`" :alt="item.displayDetails.name">
                </div>
                <div v-else @click = "$router.push('/products/' + item.id  + '/' + item.displayDetails.name.replace(/\s+/g, '-'))" class="no-product-img" >
                  <img src="../../assets/images/image-icon.svg" alt="Default image">
                </div>
                <span v-if="item.approved === 0" style="color: #fde910;font-size: 20px;margin-top: 50px" class="g-filter">{{$t('products.waiting')}}</span>
                <span v-else-if="item.approved === 2" style="color: red;font-size: 20px;margin-top: 50px" class="g-filter">{{$t('products.rejected')}}</span>
                <v-list-tile-avatar v-if="item.User" class="g-filter">
                  <router-link v-if="item.User.image" :to="'/accounts/' + item.User.id" class="prouduct-avatar">
                    <img :src="`${ROOT_API}${item.User.image}`" :alt="$t('avatar')">
                  </router-link>
                  <i v-else class="material-icons">
                    account_circle
                  </i>
                </v-list-tile-avatar>
              </v-layout>
            </router-link>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'Related-products',
  props: ['relatedProducts'],
  data: () => ({
    ROOT_API: process.env.ROOT_API
  })
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/desktop/products.scss";
</style>



// WEBPACK FOOTER //
// src/components/products/relatedProducts.vue